export const easeInOutMotionTransition = {duration: 0.4, ease: [0.4, 0, 0.2, 1] as const};
export const easeInOutMotionTransition = {duration: 0.4, ease: [0.4, 0, 0.2, 1] as const};
